import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Wizard from './Wizard';
import ExistingClientQuickStart from './ExistingClientQuickStart';

export default function WizardV3(props) {
  const { api } = useAuth();
  const [showExistingClientQuickStart, setShowExistingClientQuickStart] = useState(false);

  const cancelWizard = () => {
    props.setWizardResumeData?.(null);
    props.setActiveView?.('dashboard');
  };

  const routeExistingClientToQuickStart = event => {
    const button = event.target?.closest?.('[data-testid="wizard-client-existing"]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    setShowExistingClientQuickStart(true);
  };

  const openProject = project => {
    setShowExistingClientQuickStart(false);
    props.setSelectedProject?.(project);
    props.setWizardResumeData?.(null);
    // Quick-start is still part of project creation: entitled Master
    // projects must enter Design DNA before the Content board.
    props.setActiveView?.(project?.project_mode === 'master' ? 'dna' : 'content');
  };

  const resumeIncompleteClient = wizardState => {
    setShowExistingClientQuickStart(false);
    props.setWizardResumeData?.(wizardState);
  };

  return <>
    <div data-testid="wizard-v3-router" onClickCapture={routeExistingClientToQuickStart}>
      <Wizard {...props} onCancel={cancelWizard} />
    </div>

    {showExistingClientQuickStart && (
      <ExistingClientQuickStart
        api={api}
        onClose={() => setShowExistingClientQuickStart(false)}
        onOpenProject={openProject}
        onResumeWizard={resumeIncompleteClient}
      />
    )}
  </>;
}
